<template>
  <v-dialog v-model="isOpen" persistent fullscreen hide-overlay>
    <v-card width="100%" style="background-color: #f8f8f8">
      <v-toolbar class="fixed-bar">
        <v-btn icon @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>
          {{ title || 'Visualizar Documento' }}
        </v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <vue-pdf-embed
        v-if="pdfSource"
        class="mx-auto mt-2"
        style="max-width: 800px"
        justify="center"
        :source="`data:application/pdf;base64, ${pdfSource}`"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';

export default {
  name: 'DocumentModal',
  components: {
    VuePdfEmbed,
  },
  props: {
    pdfBase64: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isOpen: false,
      pdfSource: null,
      documentTitle: '',
    };
  },
  methods: {
    openModal(pdfBase64, title) {
      this.pdfSource = pdfBase64;
      this.documentTitle = title;
      this.isOpen = true;
    },
    closeModal() {
      this.isOpen = false;
      this.pdfSource = null;
      this.documentTitle = '';
    },
  },
};
</script>
<style scoped>
.fixed-bar {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 0;
  z-index: 2;
}
</style>
